<template>
  <div>
    <!-- <div class="hero simple" style="background-image: url('/static/leeno/events_first_bg.jpg')">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.events') }}</h1>
      </div>
    </div> -->
    <div class="menu_bg">
    </div>
    <div class="product-container">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.events') }}</h1>
      </div>
    </div>
    <div class="sections-container">
      <div style="width: 420px;max-height: 480px;">
        <section id="nav_menu-2" class="widget widget_nav_menu">
          <h2 class="widget-title">{{ $t('messages.events') }}</h2>
          <div class="menu-about-menu-container">
            <ul id="menu-about-menu" class="menu">
              <li v-for="(item, index) in menuItems" :key="item.id" :class="{ active: activeIndex === index }">
                <div class="a_container">
                  <a @click="handleClick(index)">
                    {{ item.title }}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="right-container">
        <div v-if="activeIndex == 0" class="section-content">
          <div class="four-grid-container">
            <div v-for="(item, index) in items" :key="index" class="grid-item" @click="gotoNews(index)">
              <div class="content-wrapper">
                <img :src="item.src" alt="grid image" />
                <p style="color: #6f6f6f;font-size: 18px;">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeIndex == 1" class="section-content">

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CategoryMenu from "@/components/CategoryMenu.vue";
export default {
  components: {
    CategoryMenu
  },
  data() {
    return {
      activeIndex: 0,
      menuItems: [
        { id: 1001, title: 'News' },
        { id: 1002, title: 'Events' },
      ],
      items: [
        { src: 'https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/CNC车床.jpg', title: 'pogopin弹簧针简介' },
        { src: 'https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/CNC车床2.jpg', title: '半导体测试探针简介' },
      ]
    }
  },

  methods: {
    gotoNews(index) {
      if (index === 0) {
        this.$router.push({ path: "/newsPogopinProbeIntro" })
      } else if (index === 1) {
        this.$router.push({ path: "/newsTestProbeIntro" })
      }
    }
  }
};
</script>

<style scoped>
.hero.simple {
  height: 475px;
  width: 100%;
  position: relative;
  background-size: cover;
}

.hero.simple:after {
  z-index: 1;
  content: "";
  background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
}

@media (max-width: 1539px) {
  .hero.simple .content {
    padding: 24px 0 18px 48px;
  }
}

.hero.simple .content {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.hero.simple .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

.menu_bg {
  height: 100px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-color: #00579C;
}



.product-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.content {
  /* position: absolute; */
  /* bottom: 0; */
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.content .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}


@media (max-width: 1539px) {
  .sections-container {
    -webkit-padding-start: 49px;
    padding-inline-start: 49px;
    -webkit-padding-end: 49px;
    padding-inline-end: 49px;
    gap: 70px;
  }
}

@media (max-width: 1919px) {
  .sections-container {
    gap: 80px;
  }
}

@media (min-width: 1920px) {
  .sections-container {
    gap: 90px;
    padding-inline-start: 80px;
    padding-inline-end: 80px;
  }
}

.sections-container {
  display: flex;
  /* justify-content: space-between; */
  flex-direction: row;
  margin-top: 54px;
  -webkit-padding-start: 70px;
  padding-inline-start: 70px;
  -webkit-padding-end: 70px;
  padding-inline-end: 70px;
}

.section-content {
  /* margin-left: 80px; */
  max-width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center;

}


.widget_nav_menu {
  padding: 24px 0;
}

.widget {
  margin: 0 0 1.5em;
}

.widget_nav_menu {
  width: 100%;
  height: 100%;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, .1607843137);
  border-radius: 10px;
  background-color: #fafafa;
  padding-top: 24px;
}

.widget_nav_menu h2 {
  margin: 0;
  font-size: 37px;
  line-height: 56px;
  color: #0077b4;
  -webkit-padding-start: 40px;
  padding-inline-start: 40px;
}

.widget_nav_menu .menu-about-menu-container ul {
  list-style: none;
  margin: 10px 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.widget_nav_menu .menu-about-menu-container ul li {
  height: 54px;
  padding-top: 12px;
}

.widget_nav_menu .menu-about-menu-container ul li:hover {
  background-color: #ddd;
}

.widget_nav_menu .menu-about-menu-container ul li.active {
  background-color: #ccc;
}

.widget_nav_menu .menu-about-menu-container ul li a {
  text-decoration: none;
  font-size: 17px;
  color: #6f6f6f;
  -webkit-padding-start: 40px;
  padding-inline-start: 40px;
  transition: linear-gradient .2s ease-in-out;
}

/* 新增的样式 */
.a_container {
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.menu a {
  text-decoration: none;
  cursor: pointer;
  background-color: transparent;
  color: black;
  padding: 5px 10px;
}

.menu a:hover {
  background-color: #ddd;
}

.menu a.active {
  background-color: #ccc;
}

.right-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  flex-grow: 1;
}

.four-grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 创建两列 */
  gap: 10px;
  /* 格子间的间距 */
}

.grid-item {
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  /* 改变鼠标悬停时的指针样式 */
  transition: transform .2s;
  /* 添加简单的过渡效果 */
}

.grid-item:hover {
  transform: scale(1.05);
  /* 鼠标悬停时稍微放大 */
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 水平居中 */
  justify-content: center;
  /* 垂直居中（可选） */
  height: 100%;
}

.grid-item img {
  max-width: 100%;
  margin-bottom: 10px;
  /* 图片与文字之间的间距 */
}

.grid-item p {
  margin: 0;
}

.article-container {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.article-section {
  margin-bottom: 40px;
}

h1,
h2 {
  color: #333;
}

p {
  line-height: 1.6;
  text-align: justify;
}

.conclusion p {
  font-weight: bold;
  color: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/firstLevel/Events.vue